import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

let LOG_COLUMNS = {
  'assign_ok'        : { name: '案件を受けました',               url: '' },
  'assign_ng'        : { name: '案件を断りました',               url: '' },
  'draft_submission' : { name: '下書きを提出しました',           url: '' },
  'insight_complete' : { name: 'インサイトデータを提出しました', url: '' },
};

class SummaryProjectsLogs extends React.Component {
  render() {
    let data = this.props.data;
    
    return (
      <div className="summary-projects-logs">
        <h2>履歴</h2>
        
        { (data.projects_logs.length == 0) && <p className="none">履歴がありません</p> }
        
        <ul>
          { data.projects_logs.map((d, key) => {
            let val = LOG_COLUMNS[d.mode];
            let influencer = data.workflow.influencers[d.insta_user_id];
            
            if( val == undefined || influencer == undefined ) return null;
            
            return (
              <li key={key}>
                <h6 className="date">{Utils.setDate(d.register_date, 'YYYY年M月D日 HH:mm')}</h6>
                <div className="act-box">
                  <div className="thumbnail">
                    <img src={influencer.thumbnail} />
                  </div>
                  <div className="act-title">
                    <p className="name"><span onClick={data.event.showInfluencer.bind(this, influencer.insta_user_id, true)}>@{influencer.insta_id}</span>が</p>
                    <p className="act">{val.name}</p>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default SummaryProjectsLogs;